import React from "react";
import { debounce } from "../../utils";
import { Search } from "../input";

interface FilterProps {
  compNo?: string;
  iccNo?: string;
  month?: string;
  invType?: string;
  onDebounce?: (value: PhotoFilterState) => void;
}

export interface PhotoFilterState {
  compNo: string;
  iccNo: string;
  month: string;
  invType: string;
}

export const PhotoFilter: React.FC<FilterProps> = (props) => {
  const {
    compNo = "",
    iccNo = "",
    month = "",
    invType = "",
    onDebounce,
  } = props;

  const [state, setState] = React.useState<PhotoFilterState>({
    compNo,
    iccNo,
    month,
    invType,
  });

  React.useEffect(() => {
    debounceOnChange(state);
    // eslint-disable-next-line
  }, [state]);

  const handleOnMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      month: event.target.value,
    });
  };

  const handleOnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    setState({
      ...state,
      [key]: event.target.value,
    });
  };

  // eslint-disable-next-line
  const debounceOnChange = React.useCallback(
    debounce((value: PhotoFilterState) => {
      if (onDebounce) onDebounce(value);
    }, 500),
    []
  );

  return (
    <>
      <div className="filter">
        <Search
          value={state.compNo}
          className="arcgis-search"
          placeholder="Comp No."
          onChange={(evt) => handleOnChange(evt, "compNo")}
        />
        <Search
          value={state.iccNo}
          className="arcgis-search"
          placeholder="ICC No."
          onChange={(evt) => handleOnChange(evt, "iccNo")}
        />
        <div>
          <input
            type="month"
            value={state.month}
            onChange={handleOnMonthChange}
            className="input arcgis-search"
            style={{ padding: "0px 8px" }}
          />
        </div>
        <Search
          value={state.invType}
          className="arcgis-search"
          placeholder="Inv Type"
          onChange={(evt) => handleOnChange(evt, "invType")}
        />
      </div>
    </>
  );
};
